export var XbpmFormType;
(function (XbpmFormType) {
    XbpmFormType["PROCESS"] = "PROCESS";
    XbpmFormType["TASK"] = "TASK";
    XbpmFormType["FREE"] = "FREE";
})(XbpmFormType || (XbpmFormType = {}));
export var XbpmActionType;
(function (XbpmActionType) {
    XbpmActionType["NEXT"] = "NEXT";
    XbpmActionType["CANCEL"] = "CANCEL";
    XbpmActionType["SAVE"] = "SAVE";
    XbpmActionType["ADD_BLOCK"] = "ADD_BLOCK";
    XbpmActionType["UPDATE_BLOCK"] = "UPDATE_BLOCK";
    XbpmActionType["DELETE_BLOCK"] = "DELETE_BLOCK";
    XbpmActionType["OPEN_MODAL_FORM"] = "OPEN_MODAL_FORM";
    XbpmActionType["CLOSE_MODAL_FORM"] = "CLOSE_MODAL_FORM";
    XbpmActionType["FRONT_CLICK"] = "FRONT_CLICK";
    XbpmActionType["NAVIGATE"] = "NAVIGATE";
})(XbpmActionType || (XbpmActionType = {}));
/**
 * default block types
 */
export var XbpmBlockType;
(function (XbpmBlockType) {
    XbpmBlockType["EXTENSION"] = "EXTENSION";
    XbpmBlockType["GROUP"] = "GROUP";
    XbpmBlockType["PANEL"] = "PANEL";
    XbpmBlockType["TABLE"] = "TABLE";
    XbpmBlockType["TABLE_ROW"] = "TABLE_ROW";
    XbpmBlockType["TABS"] = "TABS";
    XbpmBlockType["TAB"] = "TAB";
})(XbpmBlockType || (XbpmBlockType = {}));
/**
 * default field types
 */
export var XbpmFieldType;
(function (XbpmFieldType) {
    XbpmFieldType["ATTACHMENT"] = "ATTACHMENT";
    XbpmFieldType["AUTOCOMPLETE"] = "AUTOCOMPLETE";
    XbpmFieldType["BUTTON"] = "BUTTON";
    XbpmFieldType["CHECKBOX"] = "CHECKBOX";
    XbpmFieldType["CUSTOM"] = "CUSTOM";
    XbpmFieldType["DATE"] = "DATE";
    XbpmFieldType["DROPDOWN"] = "DROPDOWN";
    XbpmFieldType["IMAGE"] = "IMAGE";
    XbpmFieldType["INTEGER"] = "INTEGER";
    XbpmFieldType["LABEL"] = "LABEL";
    XbpmFieldType["MASK"] = "MASK";
    XbpmFieldType["MONEY"] = "MONEY";
    XbpmFieldType["MULTISELECT"] = "MULTISELECT";
    XbpmFieldType["RADIOBUTTON"] = "RADIOBUTTON";
    XbpmFieldType["SLIDER"] = "SLIDER";
    XbpmFieldType["STRING"] = "STRING";
    XbpmFieldType["TEXT"] = "TEXT";
    XbpmFieldType["MENU"] = "MENU";
})(XbpmFieldType || (XbpmFieldType = {}));
export var XbpmFormulaType;
(function (XbpmFormulaType) {
    /**
     * Element properties calculation
     */
    XbpmFormulaType["CALC"] = "formulaFrontCalc";
    XbpmFormulaType["VISIBILITY"] = "formulaFrontVisibility";
    XbpmFormulaType["ENABLED"] = "formulaFrontEnabled";
    XbpmFormulaType["READONLY"] = "formulaFrontReadOnly";
    XbpmFormulaType["OPTIONS"] = "formulaFrontOptions";
    /**
     * Element validation err function or function returns yup schema
     */
    XbpmFormulaType["VALIDATE"] = "formulaFrontValidate";
    /**
     * * 'FRONT_CLICK' action changes function
     */
    XbpmFormulaType["CLICK"] = "formulaFrontClick";
    /**
     * Place search function, result is [<input block>: ElementDef, <prev block>: ElementDef]
     */
    XbpmFormulaType["FIND_PLACE"] = "formulaFrontFindPlace";
    /**
     * Block search function, result is ElementDef
     */
    XbpmFormulaType["FIND_BLOCK"] = "formulaFrontFindBlock";
    /**
     * Element's custom request (like suggestion items for autocomplete)
     */
    XbpmFormulaType["QUERY"] = "formulaFrontQuery";
    /**
     * Request (save, next, open child, save child, add/del block) payload mapping function
     */
    XbpmFormulaType["REQUEST"] = "formulaFrontRequest";
    /**
     * Result handlers, ex:
     * * formulaQuery -> formulaOk (map data) | formulaErr (prepare display err);
     * * block update request -> formulaOk -> close modal, clear fields
     */
    XbpmFormulaType["OK"] = "formulaFrontOk";
    XbpmFormulaType["ERR"] = "formulaFrontErr";
})(XbpmFormulaType || (XbpmFormulaType = {}));
//# sourceMappingURL=xbpm.enums.js.map